<div class="container">
    <p class="text-center">Hi, I'm Blake! This page is under construction, but will be used to host or link to some of my software projects.</p>
</div>